module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("ASHTON")]), _vm._v(" "), _c('p', {
    staticClass: "let"
  }, [_vm._v("Hey, baby. I’m sorry I am just now responding to your e-mail. Our Internet here is not real dependable and 4G is nonexistent, so my phone is no help. I miss you like crazy. I think about you all day and wonder what you’re doing. We’re spending most of our days hiking. The trail we took yesterday led to an amazing waterfall. After five miles uphill in the heat, the ice-cold water at the falls felt great. I kept wishing you were here.")]), _vm._v(" "), _c('p', {
    staticClass: "let"
  }, [_vm._v("It is safe to say my future is not in fishing. I suck at it. Cade is kicking my tail in catches. He told me yesterday "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("I needed to stick with football. LOL. I am enjoying my time with him. Thanks for understanding how much I needed to do this. He needs me right now. His big brother will be leaving in a year and I’ll be a phone call away, but I won’t be there to watch his football practice or help him with his first crush. I’m trying to share all my wisdom with him now.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "let"
  }, [_vm._v("I love you, Ashton Sutley Gray, so very much. I’m the luckiest guy in the world. ")]), _vm._v(" "), _c('p', {
    staticClass: "let"
  }, [_vm._v("Sawyer")]), _vm._v(" "), _c('p', {
    staticClass: "let"
  }, [_vm._v("Sawyer,")]), _vm._v(" "), _c('p', {
    staticClass: "let"
  }, [_vm._v("I figured your delayed response had to do with Internet issues. The connection up in the mountains can’t be that great. At least not up in a secluded cabin like y’all are in. I miss you, too. I’m glad you’re getting in some big brother time with Cade. I know it means so much to him. ")])]), _c('p', {
    staticClass: "let"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("As for me, I am working at the church a good bit. Nothing much to do with you gone. I haven’t been going to the field on the weekends. I clean the church ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("mostly, then rent a movie. Leann and Noah are together officially now. When she isn’t working, she is with him. So that leaves me without anyone. I’m so used to spending all my time with you. Give Cade and Catherine a hug from me. ")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "let"
  }, [_vm._v("I am counting down the days until I see your face again. ")]), _vm._v(" "), _c('p', {
    staticClass: "let"
  }, [_vm._v("Love u bunches,")]), _vm._v(" "), _c('p', {
    staticClass: "let"
  }, [_vm._v("Ashton")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("I stared at the computer screen after I clicked send. The fact I hadn’t mentioned Beau bothered me a little. I started to tell him about giving Beau and Nicole a ride home. We never really talked about Beau anymore. Sawyer did sometimes when he was worried about him. For most of Sawyer’s life he’s taken care of Beau. Beau was the son of the Vincent brother who had lived a wild life up until the day he crashed his motorcycle into an eighteen-wheeler. Beau had been in first grade when it happened. I remember his eyes being bloodshot from crying for months. He would sneak out of his trailer and come to my house in the middle of the night. I’d slip outside my window, and we would sit on my roof for hours thinking of things we could do to make him feel better. Normally those ideas would ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("lead to serious mischief that Sawyer had to bail us out of. Sawyer was the son of the good Vincent brother. Sawyer’s father had been the oldest of the two Vincent brothers. He had gone to law school and made a fortune defending the average Joe against insurance companies. The town loved Harris Vincent and his beautiful, churchgoing, tennis-playing, junior league–attending wife, Samantha Vincent, and of course their talented, all-American oldest son.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("This town wasn’t big, and like any small southern town we all knew everyone’s business. Their past was common knowledge. Their parents’ pasts were no secret. We didn’t have secrets in Grove, Alabama. It wasn’t possible—well, except maybe at the field. In the dark shadows of the pecan grove that surrounded the large open field where the Mason boys held their famous parties, I’m sure were many secrets. It was the only place where the little ole ladies couldn’t watch us from their front porch swings and where the only eyes around were too busy with their own mischief to notice ours. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Reaching over, I picked up the picture Sawyer had framed and given to me of us at a field party last month. His kind smile and bright green eyes made me feel guilty. I hadn’t done anything wrong really. I’d just left out the fact I had helped Beau get home safe last night. I should have told him. Setting the picture back down on the desk, I stood up and walked over to the closet to find something to wear. I needed to get ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("out of the house. This summer was going to go by at a snail’s pace if I didn’t find something to do. My Grana was back home from visiting her sister up in Savannah. I could go volunteer at the nursing home, then go visit Grana. That way, when I e-mailed Sawyer tomorrow, I could tell him I’d gone to the nursing home to see his great-grandmother. He’d like that. ")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Once I’d done my good deed for the day and visited with Great-Grandma Vincent, I headed to Grana’s house. I was anxious to see her. I always missed her like crazy when she was away. With Sawyer and Grana gone, I really had felt all alone. At least she was back now. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The minute my car door closed, Grana’s front door opened and out she stepped, grinning and holding a tall glass of sweet iced tea. Her white-blond hair barely brushed her shoulders, and I bit my lip to keep from smiling. We’d had a discussion about the fact she needed to cut her hair before she left. It was getting too long for someone her age. I’d told her so, and she’d waved me off as if I didn’t know what I was talking about. Guess she changed her mind. The twinkle in her green eyes told me she knew what I was thinking. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, looky who decided to stop by and visit her Grana. I was beginning to wonder if you were requiring a written invitation these days,” she teased. I laughed and walked up the steps to hug her. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“You just got home yesterday,” I reminded her. She took a sniff of my shirt and leaned back to look at me. ")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Smells like somebody stopped by the old folks home to visit her boyfriend’s great-grandmama before she came to see hers.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, stop it. I was giving you time to sleep in. I know traveling is hard on you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She took my hand and led me over to sit down beside her on the front porch swing. The diamonds on her fingers glistened against the sunlight. The cold glass she held was pressed into my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Here, drink this. I poured it as soon as I saw that little car pull in the drive.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could relax here. This was Grana. She didn’t expect me to be perfect. She just wanted me to be happy. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So you talked to that boyfriend of yours since he’s been gone, or are you having you some fun times with another fella while he’s away?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I spewed the tea in my mouth and shook my head as I began to cough. How was it she always knew what was going on when no one else did?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, who is he? He’s made you spit tea all over my lap. I at least want a name and a few details.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Shaking my head, I turned so I could look her in the eyes. “There is no one. I got strangled on my tea because you asked ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("me such an insane question. Why would I cheat on Sawyer? He’s perfect, Grana.” ")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("She made a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hmph")]), _vm._v(" sound and reached over to pat my leg. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ain’t no man perfect, baby girl. Not a one. Not even your daddy. Although he thinks he is.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She always joked about Daddy being a pastor. He’d been a “hell-raiser” growing up, according to her. When she told me stories about him as a kid, her eyes would light up. Sometimes I could swear that she missed the person he used to be. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sawyer’s as perfect as it gets.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, I don’t know about that. I drove by the Lowry’s this morning, and his cousin Beau was out cutting their grass.” She paused and shook her head, a big grin on her face. “Girl, there ain’t a boy in this town who can hold a candle to Beau Vincent with his shirt off.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Grana!” I swatted her hand, horrified that my grandmother had admired Beau shirtless. ")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "fl"
  }, [_vm._v("She chuckled. “What? I’m old, Ashton baby, not blind.” I could only imagine how Beau looked shirtless and sweaty. I’d almost had a wreck last week when I’d passed the Green’s and he’d been cutting their grass shirtless. It was hard not to look at him. I’d told myself I had just been examining the tattoo on his ribs, but of course I knew the truth. His well-defined abs were really hard to ignore. It just wasn’t possible. Then something about the ink on them made his abs even sexier. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“I ain’t the only old woman looking. I’m just the only one honest enough to admit it. The others just hire the boy to cut their grass so they can sit at the window and drool.” ")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("This was why I loved Grana. Being with her always made me laugh. She accepted life for what it was. She didn’t pretend or put on airs. She was just Grana. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I wouldn’t know how Beau looks without a shirt on,” I said, which was a lie. “I do know he’s nothing but trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Grana clicked her tongue and used her feet to give us a good push. “Trouble can be a lot of fun. It’s the straight and narrow that makes life tedious and boring. You’re young, Ashton. I’m not saying you need to go out and ruin your life. I’m just saying some excitement is good for the soul.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An image of Beau slouched down in the seat beside me in his truck last night staring at me through his thick curly lashes made my pulse rate increase. He was definitely more than a little excitement. He was lethal. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Enough about boys. I have one, and I’m not in the market for another. How was your trip?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Grana smiled and crossed her legs. One high-heeled backless sandal dangled from her hot pink toenails. It was hard to believe she was my straightlaced father’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We visited. Drank some whisky sours. Caught us a few shows at the theater. That sort of thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sounded like the usual trip to Aunt Tabatha’s. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“Did Daddy come by to check on you this morning?” ")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("She sighed dramatically. “Yes, and he of course prayed for my soul. The boy has no sense of adventure.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I smiled into my glass of iced tea. Grana was so much fun. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You best not repeat that to him either. I have him over here enough, preaching at me.” She nudged my leg with hers. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I never do, Grana.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Grana gave us another push with her foot. “So, if you aren’t gonna go find yourself a tattooed sexy bad boy to spend your summer with, then you and I need to do something. Can’t have you cleaning the church every day. Where’s the excitement in that?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Shopping. We could always go shopping,” I replied. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s my girl. We will shop. But not today. I have to unpack and clean this place up. We will make a date later this week. Just you and me. Maybe we can find us some fellas while we are out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shaking my head, I laughed at her teasing comment. She really wasn’t a fan of Sawyer. She was the only person in this town who didn’t think he walked on water. ")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "fl"
  }, [_vm._v("After making plans to go shopping with Grana, I headed back to the house. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("I’d managed to spend a good part of the day out of my bed")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("room. I could finish up the rest of the daylight hours with a good book.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Luckily, neither of my parents was home when I pulled into the driveway. When Daddy was home, he would always come up with some job at the church I needed to do. I wasn’t in the mood to spend the rest of my day making sure all the pews had a hymnal or wiping down tables in the Sunday school rooms. I just wanted to go read a steamy romance novel and live in the fictional pages for a little while. ")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_vm._v("The moment I stepped into my bedroom to change out of my clothes, which reeked of disinfectant spray and old people, my phone dinged, alerting me of a text message. Digging into my pocket, I pulled my phone out and stood staring down at the screen as a series of emotions ran through me. ")]), _vm._v(" "), _c('p', {
    staticClass: "TXM"
  }, [_vm._v("Beau: Meet me at the hole.")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_vm._v("The hole was the small lake on the farthest part of Sawyer’s property. Beau wanted to meet me out there alone? Why? My heart sped up thinking about what it was Beau was planning. I shifted my eyes to the romance novel I’d been going to read and decided that an afternoon back in the woods with Beau Vincent would be more exciting. Guilt was somewhere inside me, trying hard to beat its way past the sudden wicked need to do something wrong. Before I could come to my senses and change my mind, I replied:")])]), _c('p', {
    staticClass: "TXM"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Me: Be there in 15.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "txb"
  }, [_vm._v("My heart hammered against my chest with nervous excitement, or maybe it was the fear of getting caught. I wasn’t really doing anything wrong. I mean, Beau was my friend—sort of. He was lonely too. It wasn’t like I was going to the hole to make out with him. He probably just wanted to finish the conversation we’d had in his truck last night. He was sober now. More than likely he just wanted to clarify that he hadn’t meant for me to take anything the wrong way. It wasn’t like we were going to go swimming together or anything. ")]), _vm._v(" "), _c('p', {
    staticClass: "TXM"
  }, [_vm._v("Beau: Wear a swimsuit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Okay. Maybe we were going to go swimming. I didn’t respond. I wasn’t sure what to say. The right thing to do would be to say no. But I always did the right thing. Always. Just this once I wanted to do what I wanted to do. I let the bad girl out just a little. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("I walked toward my closet and went for the small bag tucked away on the top shelf. The red bikini I’d bought for Sawyer, but never wore around him for fear he would disapprove, was nestled in the bottom of the shopping bag. So many times I’d reached for the bag but had never actually taken it out. The ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("bikini had been an impulse buy, one I figured would end up rotting away unseen. I could almost see Grana’s approving grin as I slowly pulled out the revealing swimsuit she had insisted I buy. ")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“How’s this for trouble, Grana?” I whispered to myself before a small giggle escaped me. ")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b1"
  }, [_vm._v("BEAU")]), _vm._v(" "), _c('p', {
    staticClass: "fl"
  }, [_vm._v("If I’d ever taken the time to wonder about my soul being as black as this town seemed to believe, I knew the moment Ashton stepped out of her little white Jetta, looking like an angel from Heaven, that my soul was damned to Hell. When I’d sent the text asking her to meet me, it had been to remind me how untouchable she was. I thought seeing her “no” response would’ve been the wake-up call I needed to stop obsessing over her. Instead she had agreed, and my stupid black heart had soared. I watched her steps falter when her pretty green eyes met mine. More than anything, I wanted to walk over to her and reassure her I was going to be good. Just talk to her and watch the way her eyes lit up when she laughed or the way she nibbled on her bottom lip when she was nervous. But I couldn’t act on that desire. She wasn’t mine. She hadn’t been mine for a very long time. She shouldn’t be here, and I shouldn’t have asked. I didn’t reassure her, I kept leaning against the tree, looking like the devil and hoping she’d turn and run.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("She started walking toward me, and her perfect white teeth caught her full bottom lip between them. I’d fantasized about those lips way too many times. She’d barely covered up her long tanned legs with a pair of shorts that made me want to go to church this Sunday just to thank God for creating her. ")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hey,” she said with a nervous blush. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Damn, she was gorgeous. I’d never envied anything of Sawyer’s. I loved him like a brother. He was the only family I had truly loved. When he excelled, I silently cheered him on. He’d stood by me through a rough childhood, begging his parents to let me stay over nights when I was too scared to go back to a dark, empty trailer. He’d always had everything I didn’t have: the perfect parents, home, and life. But none of that had mattered because I’d had Ashton. Sure, we all three were friends, but Ash had been mine. She’d been my partner in crime, the one person I told all my dreams and fears to, my soul mate. Then just like everything else in Sawyer’s perfect life, he got my girl. The only thing I’d thought I could call mine had become his. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You came,” I finally replied. Her blush deepened. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, but I’m not sure why.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Me either,” I replied since we were being honest.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("She took a deep breath and put her hands on her hips. Not a pose she needed to be in with a bikini top being the only ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("thing covering her mouthwatering tits. The view was more stimulation than I needed, so I tore my eyes off her cleavage. ")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Look, Beau, I’m bored and lonely with Sawyer gone. Leann is either waiting tables at Hank’s or with Noah. I think I’d like to be . . . friends. You were my best friend for eight years of my life. I’d like to find that again.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She wanted us to be friends again? How the hell was I supposed to do that? Wanting her and never being close enough to her to touch her was one thing. She was asking for something I wasn’t real sure I could give her. But damned if the pleading look in her eyes didn’t have me caving in. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay,” I said, grabbing the hem of my shirt and yanking it over my head. “Let’s swim.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I didn’t wait to see if she’d actually step out of those tiny shorts. Part of me wanted to watch her take them off, but the other part knew my heart couldn’t handle watching Ashton shimmying out of the blasted things. My heart may be black, but it was still capable of heart failure.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("I grabbed the branch over my head and swung my body up onto it. Standing on the thick limb, I walked out and grabbed the rope swing. For a moment I was a kid again, flying out over the lake. Letting go, I flipped and dove smoothly into the still water. When my head emerged, I turned to look back on the bank in hopes I might catch a glimpse of her undressing. The little shorts were gone and Ashton was walking over to the rope. ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("This wasn’t the first time I’d seen her in a bikini, but it was the first time I’d allowed myself to enjoy the view. My heart began slamming against my chest, but I couldn’t take my eyes off her as she climbed up the ladder I’d made years ago out of pieces of wood and nailed into the tree trunk so Ash could climb the tree. She walked slowly out onto the branch and smirked down at me before grabbing the rope and swinging out over the water. After making a perfect spiral, she made one complete flip and dove into the water. It had taken me three long afternoons to teach her how to flip off the rope swing and land smoothly into the water. She’d been eight years old and determined to do everything Sawyer and I did. ")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Ashton’s head emerged from the water and tilted back as her hands smoothed the wet curls out of her face. “It isn’t as cold as I’d hoped,” she said, grinning triumphantly. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s ninety-six degrees and rising today. Before the month is over, this will feel like bathwater.” I made an attempt not to appear mesmerized by the way her long eyelashes got all spiky when they were wet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, I remember. I’ve spent as many summers in this lake as you have . . . ,” she said, trailing off as if to remind us both whose lake we were swimming in. I wanted her to be comfortable with me. If talking about Sawyer would help, then I’d talk about him. Besides, it wouldn’t hurt to keep reminding myself who she belonged to. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“Point taken. Sorry, this new Ashton doesn’t resemble the Ash I once knew. I sometimes forget Sawyer’s perfect girlfriend is the same girl who used to start mud fights with me up there on the bank.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Ashton’s easy smile quickly turned into a frustrated pout. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I wish you’d stop acting like I’m a different person, Beau. I grew up, but I’m still the same girl. Besides, you changed too. The old Beau wouldn’t have completely ignored me because he was too busy making out with his girlfriend to acknowledge my existence.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were a lot of things I could say to that, but I knew I shouldn’t. Because of Sawyer. I had to keep this friendly. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, but the old Beau wasn’t horny,” I shot back with a wink, and splashed water in her face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her familiar laughter made my chest ache a little. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Point taken. I guess having someone built like Nicole all over you is a little distracting. I can see where an old friend would rank under getting laid.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If I’d known Ashton wanted my attention at any point, I would have pushed Nicole aside and given Ashton my undivided attention. But most of the time she was wrapped in Sawyer’s arms, and I needed the distraction Nicole provided—something else I couldn’t ever admit to Ashton. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nicole isn’t very modest,” I replied, trying to lay the blame on her.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("The dimple I’d been fascinated with since the day I’d met Ashton appeared as she gave me a full smile.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nicole doesn’t even know the definition of the word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("modest. ")]), _vm._v("Now the word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("vulgar")]), _vm._v(", I’m pretty sure she’s got a grasp on its definition.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Was it my wishful thinking or did she sound jealous of Nicole? Damn, why did the idea of Ashton being jealous make me so freaking happy? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nicole’s not so bad. She just goes after what she wants,” I replied, wanting to test Ashton’s reaction.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An annoyed frown came over her face and she stiffened. I couldn’t keep the smile from forming on my lips. I liked the fact it bothered her when I defended Nicole. I liked the idea of her feeling anything more than friendship toward me, even if I’d never be good enough for her. I’d never be Sawyer, but knowing she cared just a little bit felt real good. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’ve got bad taste in women, Beau Vincent,” she replied. I watched her swim over to the pier and pull herself out to sit on the edge, giving me an extremely pleasant view of her barely covered ass. It took me a minute to remember what we’d been talking about. Ashton’s wet body on display was all my lust-addled brain seemed to be focused on. I shook my head to clear my thoughts and remembered her comment about my bad taste in women. If she only knew. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“I suppose Sawyer has better taste?” I asked, and swam ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("over to join her. She frowned and bit her bottom lip. That hadn’t been the response I was expecting. I’d meant to make her smile. ")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Maybe because I don’t rape him in public, but we both know he could do better.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What the hell did that mean? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You think so?” I managed to sound casual when all I wanted to do was demand to know who had made her feel as if she wasn’t good enough for Sawyer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She glanced over at me with a sad little smile. The late afternoon sun was directly behind her, causing the long, blond curls framing her face to softly glow. The effect made her resemble the angel she appeared to be. Untouchable unless you were the perfect Sawyer Vincent. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m not blind, Beau. I’m not saying I think I’m ugly. I know I’m passably cute. I’ve got good hair and my complexion isn’t bad. I don’t have big, blue eyes or long lashes, but my eyes aren’t bad. I’m not exactly exciting or striking. Sawyer is perfect. It’s hard to believe he wants me sometimes.” ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("I turned away from her, afraid the incredulous expression on my face would tell her more than she needed to know. I wanted to tell her how her green eyes made guys want to defend her or the way her sweet, pink lips were mesmerizing or how that one single dimple caused my pulse rate to increase. I wanted to point out how those long, tanned legs caused ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("guys to trip over themselves, and when she wore tight shirts, I fought the urge to go cover her up so every male who saw her wouldn’t go home and jack off with her image in their head. But I couldn’t say any of those things. Forcing my expression to remain casual, I glanced back at her. “I don’t think you give yourself enough credit. Sawyer didn’t just choose you because of your looks.” That’s all I needed to say. ")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("She sighed and leaned back on her hands. I had to turn my head away from her again before my eyes could zero in on her tits. I didn’t need to study them to know they were perfectly round, soft, plump, and tempting as hell. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m not always good. I try really hard to be good. I want to be worthy of Sawyer—I really do—but it’s like there is this other me inside who’s trying to get out. I fight it, but I’m not good at it all the time. Sawyer has to keep me in line.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Keep her in line? Wait . . . what? Shaking my head to clear my thoughts from how sweet her nipples would taste, I forced myself to focus on what she was saying instead of how she would taste. She didn’t think she was good enough for Sawyer? Had Sawyer made her think something was wrong with her? Surely, he didn’t know she felt this way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ash, you’ve been nothing but perfect since you decided to grow up. Sure, you used to help me put frogs in people’s mailboxes, but that girl’s gone. You wanted to be perfect, and you achieved it.” ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("She laughed and sat back up. I chanced a glance over at her. ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("The dimple was there tucked into her cheek as she gazed down at the water. ")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“If you only knew” was all she said. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tell me.” The words were out of my mouth before I could stop them. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Because I want you. Just you. The girl I know is in there hiding from the world. I want my Ash back. ")]), _vm._v("I couldn’t say it like that. She’d see too much. I had to protect myself. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Because I’d like to know you aren’t so perfect. I’d like to know the girl who I once knew was still in there somewhere.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She laughed again and pulled her legs up to rest her chin on them. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There’s no way I’m admitting all my faults to you. Considering most of them are just in my thoughts and I’ve never acted on them.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What I would give to know what bad thoughts Ashton kept locked away. I doubted they were anything as bad as I wanted them to be. But hell, just a little bit of naughty would drive me crazy. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m not asking for your deep dark secrets, Ash. I just want to know what you could possibly do wrong that makes you feel that Sawyer’s got to keep you in line.” ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Her cheeks turned pink, but she kept her eyes straight ahead. She wasn’t going to tell me. I hadn’t really expected her ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("to. Ashton had been hiding inside herself for years now. It still hurt so fucking bad when I thought of the girl I’d lost. The one she wouldn’t let me see anymore. After a few minutes of silence, I stood up and stretched. I couldn’t do this. I built a wall three years ago to keep from getting hurt. Only Ashton held the power to hurt me. I couldn’t let her do it again. ")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s fine,” I said. “I don’t really need you to tell me how you don’t always remember to take the buggy back to the return place in the parking lot or you don’t make it to the nursing home every week.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I started to walk away, angry at myself for sounding like a jerk but needing to get the hell away from her. This had been a mistake. A big-ass mistake that I was going to pay for. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Those are things Sawyer has to help me remember. . . . But I wasn’t exactly referring to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said it so softly I almost didn’t hear her. I should keep walking. I needed to stop this. But I never did the right thing. I turned back around to look at her. She was peering up at me through her wet eyelashes. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m just like any other teenage girl. I envy Nicole because she can be who she wants to be. I can’t. But it isn’t Sawyer’s fault. I’ve never been able to give in to those urges. My parents expect me to be good.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hel")]), _c('span', {
    staticClass: "txit"
  }, [_vm._v("l")]), _vm._v("? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You want to be like Nicole?” I asked in horror. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("She laughed and shook her head.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Not exactly. I don’t desire to vomit on myself and be carried inside my house drunk . . . or be known as a slut. But just once I’d like to know what it feels like to do more than just kiss. To be touched.” She stopped and turned her gaze back toward the water. “Maybe to know what the thrill of sneaking out of my house feels like or how it feels to be wanted by someone so desperately they can’t help themselves when they kiss me. Maybe to just feel desirable.” She stopped again and covered her face with both her hands. “Please forget I said all that.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Talk about an impossible request. I was having a hard enough time breathing. Ah, fuck it all to hell. I was screwed. I needed to remember Sawyer. I loved him. He was my family. He was an idiot for not kissing every damn spot on Ashton’s sexy little body and enjoying the gift he had. But he was still my family. I couldn’t do this. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She let her hands drop away from her face and turned her guilt-ridden expression back up toward me. The lost look in her eyes was killing me. I wanted to assure her nothing was wrong with her. I wanted to promise to show her exactly how insane she made me. I could show her in five minutes just how desirable she was. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She stood up.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“So now you know my secrets, Beau. Just like old times. I ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("think that makes us friends again, huh?” The smile on her lips trembled. ")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Fuck me. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah, I’d say it does.” I replied as regret consumed me. ")])]), _c('p', {
    staticClass: "CN"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f37e6cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 78
// module chunks = 0